import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [menu, setMenu] = useState({ categories: [], items: [] });
  const [promotions, setPromotions] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [s, m, p, r] = await Promise.all([
        api.get("/settings"),
        api.get("/menu"),
        api.get("/promotions"),
        api.get("/reviews"),
      ]);
      setSettings(s.data);
      setMenu(m.data);
      setPromotions(p.data);
      setReviews(r.data);
    } catch (e) {
      console.error("data load failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = useMemo(
    () => ({ settings, menu, promotions, reviews, loading, reload: load }),
    [settings, menu, promotions, reviews, loading, load]
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => useContext(DataContext);
